import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { t } from '@avanta/shared/i18n';
import NPSCompletedImage from 'assets/home/check-mynd.svg';
import ClipBoardPencil from 'assets/home/clipboard-pencil-mynd.svg';
import { type Survey } from 'types/surveys';

interface SurveyContent {
  title: string;
  heading: string;
  image: string;
  description?: string;
}

export const getSurveyContent = (
  isCompleted: boolean,
  isStarted: boolean,
  currentQuestionIndex: number,
  survey: Survey | undefined
): SurveyContent => {
  if (isCompleted) {
    return {
      title: t('NPSSurvey.Completed.title', { ns: LOCIZE_NS.HOME }),
      heading: t('NPSSurvey.Completed.heading', { ns: LOCIZE_NS.HOME }),
      description: t('NPSSurvey.Completed.description', { ns: LOCIZE_NS.HOME }),
      image: NPSCompletedImage,
    };
  }

  if (!isStarted) {
    return {
      title: survey?.introduction?.title ?? '',
      heading: t('NPSSurvey.Initial.heading', { ns: LOCIZE_NS.HOME }),
      description: t('NPSSurvey.Initial.description', { ns: LOCIZE_NS.HOME }),
      image: ClipBoardPencil,
    };
  }

  if (!survey?.questions) {
    throw new Error(t('NPSSurvey.Questions.Error', { ns: LOCIZE_NS.HOME }));
  }

  return {
    title: t('NPSSurvey.Question.title', {
      current: currentQuestionIndex + 1,
      total: survey.questions.length,
      ns: LOCIZE_NS.HOME,
    }),
    heading: survey.questions[currentQuestionIndex].text,
    image: ClipBoardPencil,
  };
};
